import { inject } from '@angular/core'
import { ED_INJECT_EXPRESS_REQUEST } from 'src/server/server.data'
import { RuntimeService } from 'src/app/service/runtime.service'

export function i18nPath () {
  if (inject(RuntimeService).isClient()) {
    return location.pathname.slice(4)
  } else {
    const request = inject(ED_INJECT_EXPRESS_REQUEST, { optional: true })
    if (request) {
      return request.originalUrl.slice(4)
    } else {
      return ''
    }
  }
}
